import React, { useMemo } from 'react';
import { FormPreset } from '@form-engine/core-application/types/form';
import BuilderElementsDrawerButton, {
    BuilderElementsDrawerButtonProps,
} from './button';

import { CollectionFill } from 'react-bootstrap-icons';
import { formatTitleCase } from '@form-engine/core-util/format-case';

export default function BuilderElementsDrawerPresetButton({
    preset,
    ...props
}: BuilderElementsDrawerButtonProps & { preset: FormPreset }) {
    const label = useMemo(() => formatTitleCase(preset?.name), [preset?.name]);

    return (
        <BuilderElementsDrawerButton
            {...props}
            preset={preset}
            dragLabel={label}
        >
            <CollectionFill /> {label}
        </BuilderElementsDrawerButton>
    );
}
